import {AttachmentApiDto} from "../../api/model/rest";
import {none, option, Option} from "ts-option";

export default class Attachment {
	constructor(public readonly id: string,
		public readonly name: string,
		public readonly description: Option<string>,
		public readonly downloadUrl: Option<string>,
		public readonly deleted: Option<boolean>) {}

	public static fromJson(json: AttachmentApiDto): Attachment {
		return new Attachment(json.id, json.name, option(json.description), none, option(json.deleted));
	}

	toJson(): AttachmentApiDto {
		return {
			id: this.id,
			name: this.name,
			description: this.description.orNull
		};
	}

	copy({downloadUrl = this.downloadUrl}) {
		return new Attachment(this.id, this.name, this.description, downloadUrl, this.deleted);
	}
}